import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-dialog-modify-node',
  templateUrl: './dialog-modify-node.component.html',
  styleUrls: ['./dialog-modify-node.component.css']
})
export class DialogModifyNodeComponent implements OnInit {
  constructor() { }
  modifyNodeSelected: FormGroup;
  @Input() idSelectedNode: string;
  @Input() cy: any;
  @Output() emitLabel = new EventEmitter<string>();
  @Output() emitDefinition = new EventEmitter<string>();
  ngOnInit(): void {
       //  form distanza meronimia
       this.modifyNodeSelected = new FormGroup({
        label: new FormControl(''),
        definition: new FormControl('')
      });
  }

  onSubmit(){
    let label = this.modifyNodeSelected.get('label').value;
    let definition = this.modifyNodeSelected.get('definition').value;
    this.emitLabel.emit(label);
    this.emitDefinition.emit(definition);
    let nodoSelected = this.cy.nodes().filter(':selected');
    this.cy.getElementById(nodoSelected.data().id).style('label',label)
    // resetto valori form
    this.modifyNodeSelected.get('label').setValue('');
    this.modifyNodeSelected.get('definition').setValue('');
    const dialogModifyNode = document.getElementById('dialogModifyNode');
    dialogModifyNode.style.display = 'none';
    sessionStorage.setItem('showDialogModifyNode','false');
  }

  closeDialog(){
    const dialogModifyNode = document.getElementById('dialogModifyNode');
    dialogModifyNode.style.display = 'none';
    sessionStorage.setItem('showDialogModifyNode','false');
  }

}
